module.exports = __webpack_public_path__ + "static/team-2-2-9d681e8dd65fbb854c26f4872bf06180.jpg";